export default __webpack_public_path__ + "static/media/pic28.81690c44.jpg";